import React from 'react';

import './ErrorPage.less';

const ErrorPage = (props) => {
    const {systemData} = props;

    return (
        <div className="ErrorPage">
            <img
                className="ErrorPage__bird-houses"
                src="//csvcus.homeaway.com/rsrcs/stab-cms-resources/0.2.4/images/errorpage/bird-houses.svg"
            />
            <img
                className="ErrorPage__birds hidden-xs"
                src="//csvcus.homeaway.com/rsrcs/stab-cms-resources/0.2.4/images/errorpage/birds.svg"
            />
            <div className="ErrorPage__info-container">
                <h2>{`Oops, the page you're looking for does not exist`}</h2>
                <p>{`We're sorry we couldn't find the page you wanted.`}</p>
                <a
                    className="btn btn-primary"
                    href={`https://${systemData.hostname}`}
                >
                    {`Return home`}
                </a>
            </div>
        </div>
    );
};

export default ErrorPage;
